import { UseQueryDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { FeatureFlagRepository } from '@front/repository/Api/FeatureFlag';
import { useQuery } from '@tanstack/react-query';
import { AuthDomain } from 'auth-lib-front';

import Project = AuthDomain.Object.Project;

import { featureFlagQueryKeys } from './queryKeys';

const repository = new FeatureFlagRepository();

type Params = {
  projectId: Project.Id;
};

type Options = {
  enabled?: boolean;
};

export const _get = ({ projectId }: Params, options?: Options) => {
  return useQuery({
    queryKey: featureFlagQueryKeys.detail(projectId),
    queryFn: async ({ signal }) => {
      return repository.get({ projectId }, { signal: signalToTimeout(DEFAULT_TIMEOUT.QUERY, signal) });
    },
    enabled: options?.enabled ?? true,
    ...UseQueryDefaultOptions,
  });
};
